import Link from "next/link";
import { useTranslation } from "next-i18next";
import { trackApplyButton } from "@/utils/dataLayer";

export default function SeoPageHero({ seoPage }) {
  const { t } = useTranslation();

  return (
    <div className="relative z-10 flex flex-col items-center justify-center bg-[linear-gradient(180deg,#091F59_0%,#1A3884_100%)] pt-[140px] pb-[70px] md:pt-[200px] md:pb-[120px] mt-[-90px] lg:mt-[-125px] overflow-hidden text-center">
      <div className="flex flex-col items-center w-full max-w-[90%] mx-auto px-[8px]">
        <div className="flex flex-col items-center gap-[4px]">
          <h1 className="xl:text-[60px] sm:text-[40px] xs:text-[32px] text-[24px] font-[700] leading-[120%] text-white max-w-[800px]">
            {seoPage?.hero?.title ?? seoPage?.hero_title ?? seoPage?.title}
          </h1>
          {(seoPage?.hero?.highlight) && (
            <h2 className="xl:text-[60px] sm:text-[40px] xs:text-[32px] text-[24px] font-[700] leading-[120%] text-main-pink max-w-[800px]">
              {seoPage.hero.highlight}
            </h2>
          )}
        </div>

        <p className="text-[14px] lg:text-[16px] text-[#FFFFFFCC] max-w-[700px] mt-[10px] md:mt-[20px]">
          {seoPage?.hero?.description ?? seoPage?.description}
        </p>

        <Link
          href={seoPage?.cta_link ?? "/apply"}
          onClick={() => trackApplyButton("seo-hero")}
          className="w-full md:w-[220px]"
        >
          <button className="flex h-[48px] w-full md:w-[220px] items-center justify-center rounded-full bg-main-pink border border-main-pink transition duration-300 text-white hover:text-main-pink hover:bg-white mt-[25px] md:mt-[50px]">
            <p className="text-[14px] font-[400] sm:text-[16px]">{seoPage?.cta_text ?? t("join-us")}</p>
          </button>
        </Link>
      </div>
    </div>
  );
}
